export default __webpack_public_path__ + "i18n/pt-BR.d5208ba2a6117babb56462383cd5d647.json";